<template>
	<modal :exibir="exibir" :titulo="titulo" custom-actions max-width="700" @close="$emit('fechar')">
		<template #body>
			<div :class="{ ajustar_modal_tamanho: !$vuetify.breakpoint.mobile }">
				<div class="modal-customizado d-flex flow-row justify-start align-content-stretch">
					<div class="infoCabecalho">
						<span class="my-6 labelModal">Motivo Reprovação</span>
						<span>{{ justificativa }}</span>
					</div>
				</div>
			</div>
		</template>
	</modal>
</template>
<script>
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'

export default {
	name: 'modal-exibir-justificativa',
	components: { LabelPersonalizado },
	props: {
		justificativa: {
			type: String,
			default: '',
		},
		titulo: {
			type: String,
			default: 'Reprovação da Adesão',
		},
		exibir: {
			type: Boolean,
		},
	},
}
</script>
<style lang="stylus">
.modal-customizado
	display flex
	flex-direction row
	justify-content space-between

	.infoCabecalho
		 display flex
		 flex-direction column
		 justify-items space-evenly
		 justify-content space-evenly
		 margin-right 20px

	.labelModal
		font-weight bold !important
		font-size 0.95em !important
		color black !important

	.label
		font-weight bold !important
		font-size 0.95em !important
		color white !important

	.item-text
		display inline-flex !important
		font-size .8em !important
		color white !important

	.theme--light.v-btn
		color #FFF !important;

.custom-button {
	text-transform: none !important;
}

.ajustar_modal_tamanho {
	height: 200px !important;
}
</style>
